import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AboutUsComponent } from './about-us/about-us.component';
import { FormationComponent } from './formation/formation.component';
import { ContactComponent } from './contact/contact.component';
import { BeneficiariesComponent } from './beneficiaries/beneficiaries.component';
import { HomeComponent } from './home/home.component';
import { TopicsComponent } from './topics/topics.component';
import { DocumentsComponent } from './documents/documents.component';
import { CampaignComponent } from './campaign/campaign.component';
import { NewsComponent } from './news/news.component';
import { NewsDetailComponent } from './news-detail/news-detail.component';
import { CampaignDetailComponent } from './campaign-detail/campaign-detail.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: '/home',
    pathMatch: 'full'
  },
  { path: 'home', component: HomeComponent },
  { path: 'nosotros', component: AboutUsComponent },
  { path: 'beneficiarios', component: BeneficiariesComponent },
  { path: 'formacion', component: FormationComponent,},
  { path: 'topicos/:idPrograma', component: TopicsComponent },
  { path: 'osc', redirectTo: 'topicos/1' },
  { path: 'agm', redirectTo: 'topicos/2' },
  { path: 'cr', redirectTo: 'topicos/3' },
  { path: 'empresas', redirectTo: 'topicos/4' },
  { path: 'documentos/:idTopico', component: DocumentsComponent },
  { path: 'campanias', component: CampaignComponent },
  { path: 'campanias/:idCampania', component: CampaignDetailComponent },
  { path: 'novedades', component: NewsComponent },
  { path: 'novedades/:idNovedad', component: NewsDetailComponent },
  { path: 'contacto', component: ContactComponent },
  { path: '**', redirectTo: 'home'},
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: 'enabled' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
